import { styled } from '@styledComponents';
import { Button } from '@components/Button';
import { Text } from '@components/typography';
import { Columns, Column } from '@components/Columns';
import { CTALink } from '@components/CTALink';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { animationTransition, animationTransitionExt } from '@utils/animationTransition';
import { Box } from '@components/Box';

export const StyledDesignColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    max-width: 100%;
  }
`;

export const StyledDesignColumn = styled(Column)`
  padding: 0px ${themeSpace(10)};
  width: auto;
  ${themeMediaQuery('below_sm')} {
    padding: 0px;
  }
  ${themeMediaQuery('sm')} {
    padding: 0px;
  }
  ${themeMediaQuery('md')} {
    padding: 0px ${themeSpace(5)};
  }
  ${themeMediaQuery('lg')} {
    padding: 0px ${themeSpace(10)};
  }
`;

export const StyledDesignTextColumn = styled(Column)`
  ${themeMediaQuery('sm')} {
    width: auto;
    padding: ${themeSpace(10)} calc(${themeSpace(11)} + ${'-12px'});
  }
`;

export const StyledDesignTextImageColumn = styled(StyledDesignTextColumn)`
  margin-top: ${themeSpace(9)};
`;

const PLACEHOLDER_IMAGE_ASPECT_RATIO = '56 / 37';

export const StyledPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  width: 330px;
  aspect-ratio: ${PLACEHOLDER_IMAGE_ASPECT_RATIO};

  ${themeMediaQuery('below_sm')} {
    width: 168px;
  }
  @media (min-width: 550px) and (max-width: 833px) {
    width: 330px;
  }
`;

export const StyledTextPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  width: 355px;
  height: 100%;
  aspect-ratio: ${PLACEHOLDER_IMAGE_ASPECT_RATIO};
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const SlideDetailsText = styled(Text)`
  max-width: 440px;
  ${themeMediaQuery('sm')} {
    text-align: center;
  }
  ${themeMediaQuery('below_sm')} {
    width: 234px;
    text-align: center;
  }
  ${themeMediaQuery('xl')} {
    max-width: 590px;
  }
  // 1032 + side spacing
  @media screen and (min-width: 1128px) {
    white-space: pre-wrap;
  }
`;

export const SlideDetailsBodyText = styled(SlideDetailsText)`
  max-width: 560px;
  ${themeMediaQuery('below_sm')} {
    width: 255px;
    text-align: center;
  }
`;

export const CarouselSlideDetails = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  opacity: 1;
  &.fade-in-enter {
    opacity: 0;
  }
  &.fade-in-enter-active {
    opacity: 1;
    transition: ${animationTransition('opacity')};
  }
  &.fade-in-exit {
    opacity: 1;
  }
  &.fade-in-exit-active {
    opacity: 0;
    transition: ${animationTransitionExt({ property: 'opacity', duration: '350ms' })};
  }
  ${themeMediaQuery('sm')} {
    align-items: center;
  }
  ${themeMediaQuery('below_sm')} {
    align-items: center;
  }
`;

export const CtaWrapper = styled(Button)`
  margin-top: ${themeSpace(7)};
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledCTALink = styled(CTALink)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;
